/* eslint-disable react/prop-types */
import React from "react";
import { keyframes, css } from "@emotion/core";
import styled from "@emotion/styled";

// Images
import ImgLeaf from "../Images/ImgLeaf";
import { mediaQueries } from "../../configs/_configSite";

const rotate = keyframes`
  0% {
    transform: rotate(-7.5deg);
  }
  50% {
    transform: rotate(7.5deg);
  }
  100% {
    transform: rotate(-7.5deg);
  }
`;

const Container = styled.section`
  z-index: 1;
  position: absolute;
  pointer-events: none;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  transition: 1s;
  @media (max-width: ${mediaQueries.md}px) {
    left: -100px;
  }
  @media (max-width: ${mediaQueries.sm}px) {
    right: -200px;
  }
`;

const leafStyle = `
  display: inline-block;
`;

const LeavesLeftOuter = ({ propRef }) => {
  const leaves = [
    {
      x: -10,
      y: -15,
      rotationStart: 0,
      origin: {
        x: 250,
        y: 0
      },
      animation: {
        type: rotate,
        ease: "ease-in-out",
        speed: 6.5
      }
    },
    {
      x: 5,
      y: -10,
      rotationStart: 50,
      origin: {
        x: 300,
        y: 0
      },
      animation: {
        type: rotate,
        ease: "ease-in-out",
        speed: 6.5
      }
    },
    {
      x: 5,
      y: -30,
      rotationStart: 330,
      origin: {
        x: 0,
        y: 200
      },
      animation: {
        type: rotate,
        ease: "ease-in-out",
        speed: 6.5
      }
    },
    {
      x: 7,
      y: 15.5,
      rotationStart: 50,
      origin: {
        x: 200,
        y: 0
      },
      animation: {
        type: rotate,
        ease: "ease-in-out",
        speed: 6.5
      }
    },
    {
      x: 5,
      y: 70,
      rotationStart: 50,
      origin: {
        x: 200,
        y: 0
      },
      animation: {
        type: rotate,
        ease: "ease-in-out",
        speed: 6.5
      }
    },
    {
      x: -9,
      y: 11.5,
      rotationStart: 140,
      origin: {
        x: 400,
        y: 250
      },
      animation: {
        type: rotate,
        ease: "ease-in-out",
        speed: 6.5
      }
    },
    {
      x: -10,
      y: 65,
      rotationStart: 15,
      origin: {
        x: 175,
        y: 0
      },
      animation: {
        type: rotate,
        ease: "ease-in-out",
        speed: 6.5
      }
    },
    {
      x: 6,
      y: 50,
      rotationStart: 330,
      origin: {
        x: 0,
        y: 50
      },
      animation: {
        type: rotate,
        ease: "ease-in-out",
        speed: 6.5
      }
    },
    {
      x: -8,
      y: 40,
      rotationStart: 65,
      origin: {
        x: 275,
        y: 0
      },
      animation: {
        type: rotate,
        ease: "ease-in-out",
        speed: 6.5
      }
    }
  ];

  return (
    <Container ref={propRef}>
      {leaves.map(leaf => (
        <div
          key={`${leaf.x}${leaf.y}`}
          css={css`
            ${leafStyle}
            position: absolute;
            pointer-events: auto;
            ${
              typeof leaf.zIndex === "undefined"
                ? "z-index: 3;"
                : `z-index: ${leaf.zIndex};`
            }
            left: ${leaf.x}%;
            top: ${leaf.y}%;
            transform-origin: ${leaf.origin.x}px ${leaf.origin.y}px;
            animation: ${leaf.animation.type} ${leaf.animation.speed}s
              ${leaf.animation.ease} infinite;
          `}
        >
          <ImgLeaf
            cssProp={`
              transform: rotate(${leaf.rotationStart}deg) !important;
            `}
          />
        </div>
      ))}
    </Container>
  );
};

export default LeavesLeftOuter;
